/**
 * @description Component-PortfolioMobile
 */
import './index.less';

import React, { FC } from 'react';

import SettleModal from '@/pages/components/SettleModal';

import MobileProfile from '../components/MobileProfile';
import PortfolioMobileTotalValues from './PortfolioMobileTotalValues';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
}
const PortfolioMobile: FC<IPropTypes> = function () {
  return (
    <div className="syn-portfolio-mobile">
      <PortfolioMobileTotalValues />
      <MobileProfile isTradePage={false} />

      <SettleModal />
      {/* <TvlModal /> */}
    </div>
  );
};

export default PortfolioMobile;
